import { Subtitle, SubtitleLink } from '../styles/shared.css'

export default function QuestionnairePrompt() {
  return <Subtitle>
    Answer a series of simple questions and Polyfill will match you with jobs you'll like.
    <SubtitleLink href='/privacy' target='_blank' rel='noreferrer'>am I the product?</SubtitleLink>
  </Subtitle>
}